import React from "react";
import { AiOutlineUser } from "react-icons/ai";

const LoadingRows = () =>
  Array.from({ length: 5 }).map((_, index) => (
    <tr key={index} className="animate-pulse">
      {Array.from({ length: 7 }).map((__, cellIndex) => (
        <td key={cellIndex} className="px-4 py-4">
          <div className="h-4 rounded bg-slate-100" />
        </td>
      ))}
    </tr>
  ));

const subscriptionClass = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "active") return "bg-emerald-50 text-emerald-700 ring-emerald-100";
  if (normalized === "expired") return "bg-amber-50 text-amber-700 ring-amber-100";
  if (normalized === "cancelled" || normalized === "inactive") return "bg-rose-50 text-rose-700 ring-rose-100";
  return "bg-slate-100 text-slate-600 ring-slate-200";
};

const NewUsers = ({ users = [], loading = false }) => {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <h3 className="flex items-center gap-2 text-lg font-bold text-slate-950">
            <AiOutlineUser className="text-sky-600" />
            New Users
          </h3>
          <p className="text-sm text-slate-500">Latest registered learners and subscription state</p>
        </div>
        <a
          href="/admin/user"
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
        >
          View all
        </a>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[860px] text-left text-sm">
          <thead>
            <tr className="border-y border-slate-100 bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Email</th>
              <th className="px-4 py-3 font-semibold">Joined</th>
              <th className="px-4 py-3 font-semibold">Plan</th>
              <th className="px-4 py-3 font-semibold">Last Login</th>
              <th className="px-4 py-3 font-semibold">Payment</th>
              <th className="px-4 py-3 font-semibold">Subscription</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading ? (
              <LoadingRows />
            ) : users.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-4 py-10 text-center text-sm text-slate-500">
                  No recent users found.
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id || user.email} className="text-slate-700 transition hover:bg-slate-50">
                  <td className="px-4 py-4">
                    <div className="font-semibold text-slate-950">{user.name}</div>
                  </td>
                  <td className="px-4 py-4 text-slate-500">{user.email}</td>
                  <td className="px-4 py-4">{user.joinedDate}</td>
                  <td className="px-4 py-4">
                    <span className="rounded-full bg-sky-50 px-2.5 py-1 text-xs font-semibold text-sky-700">
                      {user.plan}
                    </span>
                  </td>
                  <td className="px-4 py-4">{user.lastLogin}</td>
                  <td className="px-4 py-4">{user.paymentMethod}</td>
                  <td className="px-4 py-4">
                    <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${subscriptionClass(user.subscriptionStatus)}`}>
                      {user.subscriptionStatus}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewUsers;
